import { useFormStore } from 'components/ProjectSpecificComponents/Contexts/FormStoreContext'
import { observer } from 'mobx-react'
import React from 'react'
import Checkbox from './Checkbox'

interface Props {
  width?: string | number
  height?: string | number
  readOnly?: boolean
  checked?: boolean
  onCheck?: (checked: boolean) => void
}

/**
 * Component that uses the mobx store to determine
 * its colors, based on set user preferences.
 */
const PreferencesCheckbox = observer(
  ({
    ...props
  }: Props) => {
    const formStore = useFormStore()
    const { personalize } = formStore.settingsData

    return (
      <Checkbox
        {...props}
        primaryColor={personalize.colorButton}
        secondaryColor={personalize.colorButtonText??'var(--white)'}
      />
    )
  }
)

export default PreferencesCheckbox
